import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createTenantStorage } from './tenantStorage';

type MemoriesFilterState = {
  // Filter states
  searchTerm: string;

  // Actions
  setSearchTerm: (term: string) => void;
  resetFilters: () => void;
};

const STORAGE_KEY = 'terra-proxy-memories-filter-store';

const initialState = {
  searchTerm: '',
};

export const useMemoriesFilterStore = create<MemoriesFilterState>()(
  persist(
    (set) => ({
      ...initialState,

      setSearchTerm: (term: string) => set({ searchTerm: term }),
      resetFilters: () => set(initialState),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => createTenantStorage()),
      partialize: (state) => ({
        searchTerm: state.searchTerm,
      }),
    },
  ),
);
